import { Component, Input } from '@angular/core';
import {DatePipe} from "@angular/common";
import { Account } from '../../models/accountmodel';
import { Acct } from '../../models/acctmodel';
import { Commission } from '../../models/commissionmodel';
import { CommissionUpdate } from '../../models/commissionupdatemodel';
import { Topup } from '../../models/topupmodel';
import { accountService }   from '../../services/account.service';
import { billerService }   from '../../services/biller.service';
import { SharedService }   from '../../services/sharedservices.service';
import { Session } from '../../models/sessionmodel';
import { AcctResponse } from '../../models/accountresponse';
import { FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';
import {Router} from  '@angular/router';
import { CurrencyPipe } from '@angular/common';
import { Biller } from 'models/billermodel';
//import { DataTableResource } from 'angular-2-data-table';

@Component({
  templateUrl: './mapbiller.component.html',
  styleUrls: ['../../css/sb-admin.min.css'],
  providers: [accountService, billerService]
})

export class MapBillerComponent {
  @Input() responseObj: Session;
  public accounts: Account[];
  public commission: Commission;
  public commissions: Commission[];
  public data;
  public acct: Acct;
  public billers: Biller[];
  public commissionupdate: CommissionUpdate;
  public acctresp : AcctResponse;
  public topup: Topup;
  errorMessage: string;
  public itemResource;
  items = [];
  itemCount = 0;


  constructor(public _accountService: accountService,public _billerService: billerService, public router: Router, public sharedservice: SharedService) {

  }

  ngOnInit()
  {
      // call the method on initial load of page to bind dropdown
      this.getAccounts();
      this.getBillers();
      this.getCommissions();
      this.acct = new Acct();
      this.commission = new Commission();
      this.commissionupdate = new CommissionUpdate();
  }

  postCommission(isValid: boolean){
    if(isValid){
      this._accountService.postCommission(this.commission).subscribe(res => this.handlePostResponse(res), error => this.errorMessage = <any>error);
      this.getCommissions();
    }
  }

  updateCommission(isValid: boolean){
      if(isValid){
        this._accountService.updateCommission(this.commissionupdate).subscribe(res => res, error => this.errorMessage = <any>error);
        this.getCommissions();
      }
    }

  //Get the list of accounts
  getBillers() {
    this._billerService.getBillers().subscribe(res => this.handleBillerResponse(res), error => this.errorMessage = <any>error);
  }

  //Get the list of accounts
  getAccounts() {
    this._accountService.getAccounts().subscribe(res => this.handleResponse(res), error => this.errorMessage = <any>error);
  }

  //Get the list of commissions
  getCommissions() {
      this._accountService.getCommissions().subscribe(res => this.handleCommissionResponse(res), error => this.errorMessage = <any>error);
  }

   //Get the list of accounts
  retrieveCommission(storeid,biller) {
      var racct = this.commissions.find(a => a.storeid == storeid && a.billerid == biller);
      this.commissionupdate.billerid = racct.billerid;
      this.commissionupdate.storeid = racct.storeid;//racct.password;
      this.commissionupdate.rate = racct.rate;
   }


  handleBillerResponse(result){
    this.billers = result;
    console.log('Billers: ' + JSON.stringify(result));
  }

  handleResponse(result){
    this.accounts = result;
    console.log('Accounts: ' + JSON.stringify(result));
  }

  handleCommissionResponse(result){
    this.commissions = result;
    this.data = result;
  }

  handlePostResponse(result){
    this.acctresp = result;
  }


}



// WEBPACK FOOTER //
// /payu/microservice/multichannelportal/src/app/account/mapbiller.component.ts